import {hc} from 'hono/client';
import type {Router} from 'server/router';

/**
 * Typed Hono RPC client for the in-repo backend.
 *
 * The server controls the schema via the shared `Router` type, so RPC
 * responses are trusted: feature infrastructure may consume the inferred
 * DTOs directly via `InferResponseType` without runtime validation.
 */
export const rpcClient = hc<Router>('/v1');

export type RpcClient = typeof rpcClient;
